import {RouterProps} from "../../RouterProps";
import {useStatePair} from "react-type-extension";
import {UserLevelValueObject} from "../../../data/value-object/user/UserLevelValueObject";
import {UserLevelSearchOption} from "../../../data/search-option/user/UserLevelSearchOption";
import {SearchIndex} from "../../../io/HttpClient";
import {SortOrder} from "ts-protocol-extension";
import ListPageWrapper from "../../ListPageWrapper";
import {UserLevelIO} from "../../../io/UserIO";
import {UserLevelDescription} from "../../../data/description/user/UserLevelDescription";
import {UserLevelDescriptor} from "../../../data/descriptor/user/UserLevelDescriptor";
import ListOption from "../../ListOption";
import {UserLevelSearchOptionDescription} from "../../../data/description/user/UserLevelSearchOptionDescription";
import {
    applyUserLevelSearchOption,
    UserLevelSearchOptionField
} from "../../search-option-field/user/UserLevelSearchOptionField";
import ListOrder from "../../ListOrder";

enum Phase {
    List,
    Option,
    Order
}

export default function List(props: RouterProps) {
    const phase = useStatePair<Phase>(Phase.List)
    const items = useStatePair<UserLevelValueObject[]>([])
    const option = useStatePair<UserLevelSearchOption>({})
    const index = useStatePair<SearchIndex>({ pageIndex: 0n, sortOrder: [SortOrder.ASC], sortPriority: ['id'] })

    return <>
        {phase.value === Phase.List && <>
            <ListPageWrapper
                {...props}
                client={UserLevelIO}
                items={items}
                option={option.value}
                index={index}
                description={UserLevelDescription}
                descriptor={UserLevelDescriptor}
                showPost
                onPostClick={() => document.location = '/users/levels/post'}
                showFilter
                onFilterClick={() => phase.setter(Phase.Option)}
                showSort
                onSortClick={() => phase.setter(Phase.Order)}
                onItemClick={item => `/users/levels/${item.id}`}/>
        </>}
        {phase.value === Phase.Option && <>
            <ListOption
                {...props}
                option={option.value}
                description={UserLevelSearchOptionDescription}
                fields={UserLevelSearchOptionField}
                onBackClick={() => phase.setter(Phase.List)}
                onApplyClick={(key, value) => {
                    applyUserLevelSearchOption(key, value, option)
                    index.setter({ ...index.value, pageIndex: 0n })
                    items.setter([])
                }}
                onDismissClick={key => {
                    const next = { ...option.value }
                    next[key] = undefined
                    option.setter(next)
                    items.setter([])
                }} />
        </>}
        {phase.value === Phase.Order && <>
            <ListOrder
                {...props}
                index={index}
                description={UserLevelDescription}
                onBackClick={() => phase.setter(Phase.List)}
                onOrderUpdated={() => items.setter([])} />
        </>}
    </>
}